export const state = () => {
  return {}
};



// WEBPACK FOOTER //
// ./src/store/modules/adgroupReport/state.js